import { render, staticRenderFns } from "./SettingLanguage.vue?vue&type=template&id=10ea4a08&"
import script from "./SettingLanguage.vue?vue&type=script&lang=ts&"
export * from "./SettingLanguage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports